import { Injectable, InjectionToken } from '@angular/core';

// Create token that can be used to provide the service
export const CHART_SERVICE_TOKEN = new InjectionToken<ChartService>('ChartService');

/**
 * Service for managing charts in the dashboard
 * Simplified implementation to fix type errors
 */
@Injectable({
  providedIn: 'root'
})
export class ChartService {
  private charts = new Map<string, any>();
  private static instance: ChartService;

  constructor() {
    // Ensure we're using a singleton instance to avoid problems after login/logout
    if (ChartService.instance) {
      return ChartService.instance;
    }
    ChartService.instance = this;
  }

  /**
   * Check if a chart exists
   */
  hasChart(chartId: string): boolean {
    return this.charts.has(chartId);
  }

  /**
   * Create a year comparison chart
   */
  createYearComparisonChart(
    canvas: HTMLCanvasElement,
    chartId: string,
    labels: string[],
    currentYearData: number[],
    previousYearData: number[]
  ): void {
    // First destroy any existing chart with this ID
    this.destroyChart(chartId);
    
    // Store a reference to the chart
    this.charts.set(chartId, {
      type: 'yearComparison',
      canvas,
      data: { labels, currentYearData, previousYearData }
    });
    
  }

  /**
   * Create a status chart (doughnut/pie)
   */
  createStatusChart(
    canvas: HTMLCanvasElement,
    chartId: string,
    percentComplete: number
  ): void {
    // First destroy any existing chart with this ID
    this.destroyChart(chartId);
    
    // Store a reference to the chart
    this.charts.set(chartId, {
      type: 'status',
      canvas,
      data: { percentComplete }
    });
    
  }

  /**
   * Update chart data
   */
  updateChartData(chartId: string, newData: any): void {
    const chart = this.charts.get(chartId);
    if (chart) {
      chart.data = newData;
    }
  }

  /**
   * Update status chart
   */
  updateStatusChart(chartId: string, percentComplete: number): void {
    const chart = this.charts.get(chartId);
    if (chart && chart.type === 'status') {
      chart.data.percentComplete = percentComplete;
    }
  }

  /**
   * Resize a chart
   */
  resizeChart(chartId: string): void {
    if (this.charts.has(chartId)) {
    }
  }

  /**
   * Destroy a specific chart
   */
  destroyChart(chartId: string): void {
    if (this.charts.has(chartId)) {
      this.charts.delete(chartId);
    }
  }

  /**
   * Destroy all charts
   */
  destroyAllCharts(): void {
    this.charts.clear();
  }
  
  /**
   * Reset the service (use on logout)
   */
  reset(): void {
    this.destroyAllCharts();
  }
} 